import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id } from '@sigma/common/schema/Id.js';
export const StaffGetEndpointParams = z.object({
    /** Id of the staff member to get */
    id: Id,
});
/**
 * Endpoint to get staff data by id for patient app.
 */
export const StaffGetEndpoint = defineEndpoint({
    name: 'StaffGet',
    input: StaffGetEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=StaffGetEndpoint.js.map